/**
 * Unified data layer — all data comes from Supabase.
 *
 * Usage: import { getCountries, ... } from '@/lib/data-source';
 */
export * from './db-supabase';

import type { Country } from '@/lib/types';
import { getCountries, getCountryByCode } from './db-supabase';

/** Build a lookup map from country code → Country object.
 * @deprecated Use getCountryByCode() for single lookups instead. */
export function buildCountryMap(): Record<string, Country> {
  return Object.fromEntries(getCountries().map(c => [c.code, c]));
}
